import { UploadOutlined } from '@ant-design/icons'
import { Form, Modal, Upload } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import { Button } from '../Button'
import { Col } from '../Col'
import EditableTagGroup from '../EditableTagGroup'
import { Input } from '../Input'
import { Switch } from '../Switch'
import { TextArea } from '../TextArea'
import * as Yup from 'yup'
import { handleChange } from '../../../utils/handleChange'

export const AccompanimentsForm = (AccompanimentsProps: any) => {
  const { visible, onOk, onCancel, state, setState } = AccompanimentsProps
  const [errors, setErrors] = useState<any>({})
  const [form] = Form.useForm()
  console.log(form.getFieldsValue())
  const [disabled, setDisabled] = useState<any>({
    SEND_EMAIL: false
  })
  const emailSchema = useMemo(
    () => Yup.string().email('Insira um email válido!').nullable(),
    []
  )

  const handleEmailPara = async (tags: string[]) => {
    const to = tags.join(';')
    setState((prev: any) => ({ ...prev, to }))
  }

  const handleEmailCC = (tags: string[]) => {
    const cc = tags.join(';')
    setState((prev: any) => ({ ...prev, copy: cc }))
  }

  const props = {
    onRemove: (file: any) => {
      setState((state: any) => {
        const index = state.fileList.indexOf(file)
        const newFileList = state.fileList.slice()
        newFileList.splice(index, 1)
        return { ...state, fileList: newFileList }
      })
    },
    beforeUpload: (file: any) => {
      setState((state: any) => ({
        ...state,
        fileList: [...state.fileList, file]
      }))
      return false
    }
  }

  useEffect(() => {
    form.resetFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      title="Novo Acompanhamento"
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Cadastrar"
      cancelText="Cancelar"
      centered
    >
      <Col>
        <Switch
          label="Email"
          size="small"
          onChange={(checked) =>
            setDisabled((prev: any) => ({
              ...prev,
              SEND_EMAIL: checked
            }))
          }
        />
      </Col>
      <Form form={form}>
        {disabled.SEND_EMAIL && (
          <Col>
            <Form.Item
              name="to"
              label="Para"
              validateStatus={errors?.PARA ? 'error' : ''}
            >
              <div
                style={{
                  marginLeft: 100,
                  border: 'solid 1px rgba(0,0,0,0.15)',
                  padding: '8px'
                }}
              >
                <EditableTagGroup
                  label="Email"
                  onChange={handleEmailPara}
                  yupSchema={emailSchema}
                  onInputError={(e) =>
                    setErrors((prev: any) => ({ ...prev, PARA: e }))
                  }
                />
              </div>
            </Form.Item>
          </Col>
        )}

        {disabled.SEND_EMAIL && (
          <Col>
            <Form.Item
              name="copy"
              label="CC"
              validateStatus={errors?.CC ? 'error' : ''}
              // help={errors.CC}
            >
              <div
                style={{
                  marginLeft: 110,
                  border: 'solid 1px rgba(0,0,0,0.15)',
                  padding: '8px'
                }}
              >
                <EditableTagGroup
                  label="Email"
                  onChange={handleEmailCC}
                  yupSchema={emailSchema}
                  onInputError={(e) =>
                    setErrors((prev: any) => ({ ...prev, CC: e }))
                  }
                />
              </div>
            </Form.Item>
          </Col>
        )}
      </Form>

      <Col>
        <Input
          label="Assunto"
          disabled={disabled.ASSUNTO}
          value={state.subject}
          onChange={(e) => handleChange(e, 'subject', setState)}
        />
      </Col>
      <Col>
        <TextArea
          label="Descrição"
          rows={5}
          value={state.description}
          onChange={(e: any) => handleChange(e, 'description', setState)}
        />
      </Col>

      <Upload {...props} multiple>
        <Button style={{ marginLeft: 140 }} icon={<UploadOutlined />}>
          Incluir arquivo
        </Button>
      </Upload>
    </Modal>
  )
}
